// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__7ZwEH","grid_container":"style_grid_container__Pkb-0"};